<template>
    <div>
        <select class="form-control" name="system_id" id="system_id" @change="onChange($event)">
            <option value=''></option>
            <option v-for="system in options" :key="system.id" :value="system.id" :selected="selectedValue === system.id">{{ system.name }}</option>
        </select>
    </div>
</template>


<script>
export default {
    name: 'SystemSelector',
    props: [
        'selectedValue',
    ],
    data() {
        return {
            value: '',
            options: [
                { id: 'scr', name: 'SCR' },
                { id: 'communications', name: 'Comunicaciones' },
            ]
        };
    },
    methods: {
        onChange(event) {
            const selectedOption = event.target.value;
            this.value = selectedOption;
            this.$emit('update', selectedOption);
        }
    }
};
</script>

<style>
.form-control {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    height: fit-content;
}
</style>
